import React, { lazy, Suspense } from 'react'
import { CardContentProps } from './CardContent'

const LazyCardContent = lazy(() =>
    import('./CardContent').then((module) => ({ default: module.CardContent }))
)

/**
 * Body subcomponent for the track change card.
 * Renders the content of the card based on its type and suggestion data.
 * @param {CardContentProps} CardContentProps - The component props.
 * @returns {JSX.Element} The rendered body for the track change card.
 */
export const TrackChangeCardBody = ({
    cardType,
    cardSuggestion,
    classes,
}: CardContentProps) => (
    <Suspense fallback={null}>
        <LazyCardContent
            cardType={cardType}
            cardSuggestion={cardSuggestion}
            classes={classes}
        />
    </Suspense>
)
